import React from "react";
import { fetchUsers } from "directus/src/operations";

export default function CommentRenderer({ comment, className }) {
  const [usersById, setUsersById] = React.useState({});

  React.useEffect(() => {
    if (!comment) return;
    const ids = Array.from(
      new Set(
        (comment.match(/@([A-Za-z0-9-]{6,})/g) || []).map((m) => m.slice(1))
      )
    );
    if (ids.length === 0) return;

    let cancelled = false;
    (async () => {
      try {
        const res = await fetchUsers({
          fields: ["id", "first_name", "last_name", "avatar"],
          filter: { id: { _in: ids } },
          limit: ids.length,
        });
        if (cancelled) return;
        const map = {};
        (res || []).forEach((u) => {
          map[u.id] = u;
        });
        setUsersById(map);
      } catch (e) {
        // ignore
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [comment]);

  if (!comment) return null;

  const parts = [];
  const regex = /@([A-Za-z0-9-]{6,})/g;
  let lastIndex = 0;
  let m;
  while ((m = regex.exec(comment)) !== null) {
    if (m.index > lastIndex) {
      parts.push({ type: "text", value: comment.slice(lastIndex, m.index) });
    }
    parts.push({ type: "mention", id: m[1] });
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < comment.length) {
    parts.push({ type: "text", value: comment.slice(lastIndex) });
  }

  return (
    <span className={className}>
      {parts.map((p, idx) => {
        if (p.type === "text")
          return <React.Fragment key={idx}>{p.value}</React.Fragment>;
        const user = usersById[p.id];
        if (!user) {
          return (
            <span key={idx} className="font-semibold">
              @{p.id}
            </span>
          );
        }
        return ` ${user.first_name} ${user.last_name}`;
      })}
    </span>
  );
}
